import { useEffect } from 'react'
import Navbar from './components/Navbar'
import Header from './components/Header'
import WhyEPOC7 from './components/WhyEPOC7'
import KeyFeatures from './components/KeyFeatures'
import SuccessTrack from './components/SuccessTrack'
import SimplifyPlanning from './components/SimplifyPlanning'
import ProjectTracking from './components/ProjectTracking'
import RealTimeSolutions from './components/RealTimeSolutions'
import SupportSection from './components/SupportSection'
import Footer from './components/Footer'
import './LandingPage-module.css'
import { useAuthContext } from '../../hooks/useAuthContext'
import { useNavigate } from 'react-router-dom'
import { Box } from '@mui/material'

const LandingPage = () => {
  const navigate = useNavigate()

  const { user } = useAuthContext()

  useEffect(() => {
    if (user) {
      navigate('./tasks')
    }
  }, [user])

  return (
    <Box className="landing-page">
      <Navbar />
      <Header />
      <WhyEPOC7 />
      <KeyFeatures />
      <SuccessTrack />
      <SimplifyPlanning />
      <ProjectTracking />
      <RealTimeSolutions />
      <SupportSection />
      <Footer />
    </Box>
  )
}

export default LandingPage
